import * as Yup from 'yup';

const returnSchema = [
  {
    name: 'touchpos_require_card_type_on_external_payment',
    initialValue: '',
    input: {
      className: 'touchpos_require_card_type_on_external_payment',
      label: 'Require card type on external device',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_ask_signature_for_integrated_payments',
    initialValue: '',
    input: {
      className: 'touchpos_ask_signature_for_integrated_payments',
      label: 'Ask signature for integrated payments',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_external_card_payment',
    initialValue: '',
    input: {
      className: 'touchpos_disable_external_card_payment',
      label: 'Disable external device payment',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_round_cash_to_nearest_005',
    initialValue: '',
    input: {
      className: 'pos_round_cash_to_nearest_005',
      label: 'Round cash payments to nearest x cents',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_round_cash_to_nearest_x',
    initialValue: '',
    validation: Yup.number()
      .typeError('Cents must be a number')
      .positive('Cents must be greater than zero')
      .integer('Cents must be a whole number'),
    input: {
      placeholder: 'Cents',
      className: 'pos_round_cash_to_nearest_x',
      type: 'input',
    },
  },
  {
    name: 'pos_use_giftcards_with_serial_numbers',
    initialValue: '',
    input: {
      className: 'pos_use_giftcards_with_serial_numbers',
      label: 'Only allow gift cards with serial numbers',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_order_to_cashinvoice',
    initialValue: '',
    input: {
      className: 'touchpos_disable_order_to_cashinvoice',
      label: 'Disable order to cash invoice',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_new_order_to_cashinvoice',
    initialValue: '',
    input: {
      className: 'touchpos_disable_new_order_to_cashinvoice',
      label: 'Disable new order to cash invoice when 100% payment',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_enable_edit_name_in_order',
    initialValue: '',
    input: {
      className: 'touchpos_enable_edit_name_in_order',
      label: 'Disable by default print the receipt',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_enable_local_server_print',
    initialValue: '',
    input: {
      className: 'touchpos_enable_local_server_print',
      label: 'Enable Erply Point of Sale Integrator (EPSI) print',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_print_cash_in_out_receipt',
    initialValue: '',
    input: {
      className: 'touchpos_print_cash_in_out_receipt',
      label: 'Enable printing of receipt after cash in/out',
      type: 'checkbox',
    },
  },
  {
    name: 'cash_inout_open_drawer',
    initialValue: '',
    input: {
      className: 'cash_inout_open_drawer',
      label: 'Cash in/out & cash sale open drawer',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_always_open_drawer_after_sale',
    initialValue: '',
    input: {
      className: 'touchpos_always_open_drawer_after_sale',
      label: 'Always open drawer after sale',
      type: 'checkbox',
    },
  },
];

export default returnSchema;
